module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selections"
  }, [(_vm.alert.message) ? _c('div', {
    staticClass: "selections-alert"
  }, [_c('div', {
    staticClass: "alert alert-dismissable fade show",
    class: 'alert-' + _vm.alert.type
  }, [_vm._m(0), _vm._v("\n      " + _vm._s(_vm.alert.message) + "\n    ")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "selections-form",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      },
      "change": _vm.onChange
    }
  }, [_c('div', {
    staticClass: "selections-side left row"
  }, [_c('h4', [_vm._v("\n        Links\n        "), _c('small', [_c('a', {
    attrs: {
      "href": _vm.previewHref('left.jpg'),
      "target": "_blank"
    }
  }, [_vm._v("Vorschau")])])]), _vm._v(" "), _c('selections-index', {
    attrs: {
      "all": _vm.creams,
      "ids": _vm.selectedIds,
      "selected": _vm.selectedCreams.left
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "selections-side right row"
  }, [_c('h4', [_vm._v("\n        Rechts\n        "), _c('small', [_c('a', {
    attrs: {
      "href": _vm.previewHref('right.jpg'),
      "target": "_blank"
    }
  }, [_vm._v("Vorschau")])])]), _vm._v(" "), _c('selections-index', {
    attrs: {
      "all": _vm.creams,
      "ids": _vm.selectedIds,
      "selected": _vm.selectedCreams.right
    }
  })], 1), _vm._v(" "), (_vm.isAuthorized('selections-edit', _vm.id)) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-lg-2 col-3"
  }, [_c('button', {
    staticClass: "btn btn-primary save",
    attrs: {
      "disabled": !_vm.touched
    }
  }, [_vm._v("\n          Aktualisieren\n        ")])])]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "alert"
    }
  }, [_c('span', [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dd6ab91"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/frontend/components/pages/selections/edit.vue
// module id = 117
// module chunks = 1